module.exports = [
  {
    img: "./images/pages/map/巴西.jpg",
    country: "Brazil",
    country_name: "巴西",
    description: "知名代表性咖啡: 山多士(Santos)",
    content: "巴西的咖啡總產量為世界第一，主要產地集中於中部及南部的省份。巴西適合栽咖啡的區域，地勢較平坦，咖啡園多數離海拔1200公尺以下，亦無大樹遮蔭，因採收時生熟漿果同時採下，不算是精品咖啡。巴西的咖啡品質平均但較少極優的等級，其豆質較軟，烘焙過程中明顯不耐火候，各品種中Santos較著名，是以其出口港山多士為名。巴西咖啡豆性屬中性，可單品來品嚐(雖較單調一點)，或和其他種類的咖啡豆相混成綜合咖啡，一般被認為是混合調配時不可缺少的咖啡豆。",
  },
  {
    img: "./images/pages/map/古巴.jpg",
    country: "Cuba",
    country_name: "古巴",
    description: "知名代表性咖啡: 圖基諾",
    content: "古巴最好的咖啡是圖基諾(Turquino)或是特級圖基諾(Extra Turquino)。圖基諾是一個咖啡級別而不是一個地名，正如藍山咖啡 (Blue Mountain) 一樣。這種咖啡風味純正，顆粒適中，因為種植在海拔較低的地方，所以其酸度低於種植在中美洲的許多咖啡。",
  },
  {
    img: "./images/pages/map/尼加拉瓜.jpg",
    country: "Nicaragua",
    country_name: "尼加拉瓜",
    description: "知名代表性咖啡: 尼加拉瓜",
    content: "尼加拉瓜的咖啡主產於其中部和北部，遮蔭栽種為其特色，咖啡豆則以水洗處理，日曬烘乾。一般而言，尼加拉瓜的咖啡較沒有極度鮮明的特色，因此一般的尼加拉瓜豆常被用來作綜合咖啡或即溶咖啡。不過高品質的尼加拉瓜豆例如瑪拉果吉佩(Maragogipe, 一種咖啡豆十分巨大稱為象豆的樹種)則評價很高，因為它口味較為均衡，沒有其它中美洲咖啡常帶有的鮮明果酸，但有著清澈的口感以及絕佳的香醇度。這種圓潤而柔和的質感，也使得它在瓜地馬拉咖啡一般較中庸的評價中一支獨秀，受到許多人的喜愛。",
  },
  {
    img: "./images/pages/map/瓜地馬拉.jpg",
    country: "Guatemala",
    country_name: "瓜地馬拉",
    description: "知名代表性咖啡: 安堤瓜(Antigua), 薇薇特楠果(Huehuetenango)",
    content: "1750年，杰蘇伊特(Jesuit) 神父將咖啡樹引種到危地馬拉，19世紀末德國殖民者發展了此地的咖啡工業。今天，咖啡業的大部分生產都在該國的南部進行。在這裡，馬德雷 (Sierra Madre) 火山的山坡為種植上等咖啡豆提供了理想的條件。因為山脈綿延甚長，地區性氣候變化很大，因此造就了瓜國的七大咖啡產區，各有不同的風味及特色。其中以安堤瓜這個產區的咖啡因為微酸，香濃甘醇，略帶火山的碳燒味的特色使得瓜地馬拉的咖啡聞名於世界。",
  },  
  {
    img: "./images/pages/map/印尼.jpg",
    country: "Indonesia",
    country_name: "印尼",
    description: "知名代表性咖啡:爪哇(Java), 蘇門達臘曼特寧(Sumatra Mandheling)",
    content: "印尼生產咖啡豆的區域主要在爪哇、蘇門答臘、蘇拉維西等三個島，皆屬火山地形。一般認為印尼的咖啡豆香味濃厚而酸度低，略帶一點似中藥及泥土的味道。蘇門達臘(Sumatra)山區出產的曼特寧(Mandheling)世界聞名，質感豐富。爪哇島出產的羅布斯塔(Robusta)豆有獨特的氣味，因油脂豐富而常被用來作為義式濃縮咖啡的配方之一。蘇拉維西出產的咖啡則被評為有特別的草本氣息，深沈而乾淨。特別的是，印尼山間有一種特別的動物叫作麝香貓(在台灣也有出現過，目前它被列為陽明山的代表性動物之一)。因為它使得印尼出產一種幾乎是世界上最高價的咖啡-麝香貓咖啡。這種貓喜歡吃咖啡漿果，而堅硬的咖啡豆因為無法消化最後會被排出來。在經過消化道的期間，咖啡豆經過發酵作用產生了一種獨特而複雜的香味，使得不少饕客喜歡這種具有特殊香氣的咖啡。但是因為產量極少，故售價極昂，每磅在數百美元之譜。",
  },
  {
    img: "./images/pages/map/衣索比亞.jpg",
    country: "Ethiopia",
    country_name: "衣索比亞",
    description: "知名代表性咖啡: 摩卡哈拉(Mocha Harra), 耶加雪啡(Yirgacheffe)",
    content: "依索比亞是世界上最早發現阿拉比卡種咖啡樹的地方，其境內幾乎各處都在種植咖啡。其中東部高地哈拉(Harra)產有著名的哈拉摩卡，具有特別的葡萄酒香與酸，和葉門摩卡相當，屬高品質的咖啡。南部的西達莫(Sidamo)和吉馬(Djimmah)亦是知名的咖啡產地，所生產的咖啡和哈拉所生產的口感稍有不同，酸味方面較為清爽，帶有核果的香味。在西達莫中有一個小區域名叫耶加雪啡(Yirgacheffe)，其所產的咖啡有著非常迷人的特色，帶有茉莉花及檸檬的香味，以及似蜂蜜般甜甜的特殊味道，因此全球知名。",
  },
  {
    img: "./images/pages/map/坦尚尼亞.jpg",
    country: "Tanzania",
    country_name: "坦尚尼亞",
    description: "知名代表性咖啡: 克里曼佳羅(Kilimanjaro)",
    content: "坦尚尼亞也位於非洲東部，其咖啡在坦尚尼亞來說並非最主要的農業，大多是小規模經營，其餘尚出口玉米棉花等等數樣大宗農產品。咖啡多種植在坦尚尼亞北邊鄰近肯亞的克里曼佳羅(亦譯 吉力馬札羅)火山山坡，約有七成是阿拉比卡種，採水洗法處理，而其餘三成的羅布斯塔種則採日曬法處理。這裡所產的克里曼佳羅咖啡一般來說有較強的酸性，但較肯亞的稍弱些，口感則與肯亞類似，質感濃郁且帶濃厚的甘甜香氣。",
  },
  {
    img: "./images/pages/map/肯亞.jpg",
    country: "Kenya",
    country_name: "肯亞",
    description: "知名代表性咖啡: 肯亞AA",
    content: "肯亞位於東非，其咖啡的特色是帶有明顯的水果香和果酸，濃郁的口感中還有一點點酒香。 肯亞咖啡多栽種於西南部及東部的高原區， 品種都是阿拉比卡種，且都是水洗咖啡，常見的有波旁（Bourbon）、提比加（Typica）、肯特（Kents）、盧里11（Riuri 11）等四個品種。 肯亞咖啡在淺焙時明亮的果香及果酸有人評為像水果茶，可見其獨特的風味。其中知名的肯亞AA顆粒飽滿，口感豐富濃郁，頗受世人的好評。",
  },
  {
    img: "./images/pages/map/哥倫比亞.jpg",
    country: "Colombia",
    country_name: "哥倫比亞",
    description: "知名代表性咖啡: 哥倫比亞",
    content: "1808年，咖啡首次引入哥倫比亞，那是由一名牧師從法屬安地列斯(Antilles) 經委內瑞拉帶來的。今天該國繼巴西後為世界第二大咖啡輸出國，佔全球產量的約 15%，其咖啡樹多種植於縱貫南北的三座山脈中，僅有阿拉比卡種。它的產量排名雖低於巴西，不過咖啡豆品質優良，香味豐富而獨特，酸中帶甘，適中的苦味，無論是單飲或混合都非常適宜。哥倫比亞豆與巴西豆同屬調和式咖啡基本豆之最佳選擇，但其風味則較巴西豆更為甘醇些，香氣也更濃厚，除單品嚐外，也常用於調合咖啡中，用來增加咖啡的甘味，調合其它咖啡的苦味。",
  },
  {
    img: "./images/pages/map/哥斯大黎加.jpg",
    country: "Costa Rica",
    country_name: "哥斯大黎加",
    description: "知名代表性咖啡: 塔拉蘇(Tarrazu)",
    content: "哥斯達黎加的咖啡主要在種在兩個高地區，一個是首都聖荷西(San Jose)附近的高地區，而另一個則是聖荷西東南方的塔拉蘇(Tarrazu)。而塔拉蘇又是世界上主要的咖啡產地之一。因為種植在高海拔的關係，所以能增加咖啡的酸度從而增加風味，而且也由於較高海拔的夜晚溫度低，可使樹木生長緩慢，從而使咖啡豆的風味更濃郁。塔拉蘇這個地區生產的咖啡則因為帶有水果味及一些巧克力味或核果味的特殊風味，也是咖啡品嚐者非常喜愛的咖啡之一。",
  },
  {
    img: "./images/pages/map/薩爾瓦多.jpg",
    country: "El Salvador",
    country_name: "薩爾瓦多",
    description: "知名代表性咖啡: 薩爾瓦多",
    content: "薩爾瓦多的地勢屬於高地地形，是在中美洲裡面積最小的國家。因為境內有兩座平行的高山 ，火山土壤裡有著豐富的礦物質，這種特別的地理環境使得薩爾瓦多具備適合栽種咖啡的條件。薩爾瓦多的咖啡樹為阿拉比卡種，主要有Bourbon 及 Pacas兩個種別，其咖啡有清爽均勻的特色，依海拔高低分為三個等級，分別為SHG(Strictly High Grown), SG(High Grown)及SC(Central Standard)等。值得一提的是，薩爾瓦多出產一款溫泉咖啡，因為使用溫泉水作水洗處理而得名，其特別而柔順的酸味及甘甜香十分迷人，因為產量少使得單價頗高， 是其十分具有特色的咖啡。",
  },
]